import { render, staticRenderFns } from "./TitlePopup.vue?vue&type=template&id=304c81e4&scoped=true"
import script from "./TitlePopup.vue?vue&type=script&lang=js"
export * from "./TitlePopup.vue?vue&type=script&lang=js"
import style0 from "./TitlePopup.vue?vue&type=style&index=0&id=304c81e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c81e4",
  null
  
)

export default component.exports